import { getUuid } from '@sibe/utilities/common';
import type { HsHypersceneTypes } from '../../math-new/types/hyperscene-types.type';
import { HsAmbientLight } from '../objects/lights/ambient-light.class';
import { HsDirectionalLight } from '../objects/lights/directional-light.class';
import type { HsLight } from '../objects/lights/light.class';

const DEFAULT_LIGHTS_INTENSITIES: number[] = [0.26, 0.6, 0.26, 0.36, 0.36, 0.1];
const DEFAULT_LIGHTS_DIRECTIONS: HsHypersceneTypes.Array3[] = [
  [1.0, 0.0, 0.0],
  [0.0, 1.0, 0.0],
  [-1.0, 0.0, 0.0],
  [0.0, 0.0, 1.0],
  [0.0, 0.0, -1.0],
  [0.0, -1.0, 0.0],
];

export function hsMakeDefaultLights(ambientFactor: number = 0.4, directionalFactor: number = 1): HsLight[] {
  const lights: HsLight[] = [];
  const ambientLight: HsAmbientLight = new HsAmbientLight(getUuid(), 'AmbientLight');
  ambientLight.intensity = ambientFactor;
  lights.push(ambientLight);
  for (let i: number = 0; i < DEFAULT_LIGHTS_INTENSITIES.length; i++) {
    const light: HsDirectionalLight = new HsDirectionalLight(getUuid(), 'DirectionalLight');
    light.intensity = DEFAULT_LIGHTS_INTENSITIES[i] * directionalFactor;
    light.setDirection(DEFAULT_LIGHTS_DIRECTIONS[i]);
    lights.push(light);
  }
  return lights;
}
